<sc-flex [vertical]="true" [fitHeight]="true" [stretchContent]="true" class="no-field-space add-catalog-dialog">

    <sc-dialog-title>
      {{ 'Add Catalog Node' | translate: ['erp.ui.add-catalognode.title', translationService.language]}}
    </sc-dialog-title>
    <sc-separator-line></sc-separator-line>
    <sc-padding>
        <div style="width: 450px;">
            <sc-dictionary-field class="name-input" [model]="name" [maxlength]="255" defaultLabel="Name" [required]="true"
                labelDictionaryKey="erp.entity.catalognode.name" (dictionaryChanged)="onNameChanged($event)">
            </sc-dictionary-field>
        </div>
    </sc-padding>
    <sc-separator-line></sc-separator-line>
    <sc-actionbar>
        <sc-content-spacer [grow]="true"></sc-content-spacer>
        <button mat-stroked-button (click)="onClose()">
          {{ 'Abbrechen' | translate: ['erp.ui.add-catalognode.action.cancel', translationService.language]}}
        </button>
        <sc-content-spacer></sc-content-spacer>
        <button mat-flat-button (click)="onConfirm()" [disabled]="confirmDisabled()">
          {{ 'Übernehmen' | translate: ['erp.ui.add-catalognode.action.confirm', translationService.language]}}
        </button>
    </sc-actionbar>
</sc-flex>
